/* eslint-disable @typescript-eslint/naming-convention */
export enum StandardInstructionType {
  Flight = 0,
  Ground = 1,
}
